/**
 * Progreso de los retos: privado, reversible y local (spec §10.2).
 * Se guarda solo en este navegador; no viaja a ningún servidor, no puntúa y no hay clasificaciones.
 * Si el navegador bloquea el almacenamiento, la aplicación sigue funcionando sin memoria.
 */
const KEY = 'cyl1884.retos.v1';

export type ItemState = 'resuelto' | 'revelado';
export type Progress = Record<string, Record<string, ItemState>>;

export function readProgress(): Progress {
  try {
    const raw = window.localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as Progress) : {};
  } catch {
    return {};
  }
}

export function writeItem(activityId: string, n: number, state: ItemState): Progress {
  const p = readProgress();
  p[activityId] = { ...(p[activityId] ?? {}), [String(n)]: state };
  try {
    window.localStorage.setItem(KEY, JSON.stringify(p));
  } catch {
    /* sin almacenamiento: el progreso dura lo que la sesión */
  }
  return p;
}

export function clearProgress(): Progress {
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    /* ignorado */
  }
  return {};
}

export const solvedCount = (p: Progress, activityId: string) =>
  Object.values(p[activityId] ?? {}).filter((s) => s === 'resuelto').length;

/** Barajado estable: la misma pregunta se presenta siempre igual, pero la respuesta no queda la primera. */
export function shuffle<T>(items: T[], seed: string): T[] {
  let h = 2166136261;
  for (const ch of seed) h = Math.imul(h ^ ch.charCodeAt(0), 16777619);
  const out = [...items];
  for (let i = out.length - 1; i > 0; i--) {
    h = Math.imul(h ^ (h >>> 15), 2246822507) ^ Math.imul(h ^ (h >>> 13), 3266489909);
    const j = Math.abs(h) % (i + 1);
    [out[i], out[j]] = [out[j], out[i]];
  }
  return out;
}
